export const getDefaultItemPrice = (itemPrices) => {
    const defaultPrice = itemPrices.find(price => price.isDefault);
    if (!defaultPrice)
        throw new Error('Failed to find default price.');
    return defaultPrice;
};
